(() => {
  const namespace = "KashwerePressHotspots";

  if (window[namespace]) {
    window[namespace].refresh();
    return;
  }

  const safePadding = 24;
  const roots = new WeakSet();

  const parsePlacement = (value, fallback) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const positionRatio = (value, axisSize) => {
    const token = String(value || "50%").trim().split(/\s+/)[0] || "50%";

    if (token === "left" || token === "top") return 0;
    if (token === "center") return .5;
    if (token === "right" || token === "bottom") return 1;
    if (token.endsWith("%")) return parsePlacement(token, 50) / 100;
    if (token.endsWith("px") && axisSize > 0) return parsePlacement(token, axisSize / 2) / axisSize;

    return .5;
  };

  const objectPositionRatios = (image) => {
    const tokens = getComputedStyle(image).objectPosition.trim().split(/\s+/);
    const x = tokens[0] || "50%";
    const y = tokens[1] || tokens[0] || "50%";

    return {
      x: positionRatio(x, image.clientWidth),
      y: positionRatio(y, image.clientHeight),
    };
  };

  const projectedPoint = (frame, image, xPercent, yPercent) => {
    const frameWidth = frame.clientWidth;
    const frameHeight = frame.clientHeight;

    if (!frameWidth || !frameHeight) return null;

    if (!image || !image.naturalWidth || !image.naturalHeight) {
      return {
        x: frameWidth * xPercent / 100,
        y: frameHeight * yPercent / 100,
        frameWidth,
        frameHeight,
      };
    }

    const fit = getComputedStyle(image).objectFit || "cover";
    const scale = fit === "contain"
      ? Math.min(frameWidth / image.naturalWidth, frameHeight / image.naturalHeight)
      : Math.max(frameWidth / image.naturalWidth, frameHeight / image.naturalHeight);
    const renderedWidth = image.naturalWidth * scale;
    const renderedHeight = image.naturalHeight * scale;
    const position = objectPositionRatios(image);
    const offsetX = (frameWidth - renderedWidth) * position.x;
    const offsetY = (frameHeight - renderedHeight) * position.y;

    return {
      x: offsetX + (image.naturalWidth * xPercent / 100) * scale,
      y: offsetY + (image.naturalHeight * yPercent / 100) * scale,
      frameWidth,
      frameHeight,
    };
  };

  const updateRoot = (root) => {
    const frame = root.querySelector(".product-feature__image");
    if (!frame) return;

    const image = frame.querySelector("img");
    const dots = frame.querySelectorAll("[data-carousel-dot]");

    dots.forEach((dot) => {
      if (!dot.dataset.hotspotX) dot.dataset.hotspotX = dot.style.left || "50";
      if (!dot.dataset.hotspotY) dot.dataset.hotspotY = dot.style.top || "50";

      const xPercent = parsePlacement(dot.dataset.hotspotX || dot.style.left, 50);
      const yPercent = parsePlacement(dot.dataset.hotspotY || dot.style.top, 50);
      const point = projectedPoint(frame, image, xPercent, yPercent);

      if (!point) return;

      const isCropped = point.x < 0 || point.y < 0 || point.x > point.frameWidth || point.y > point.frameHeight;
      const isEdge = !isCropped && (
        point.x < safePadding ||
        point.y < safePadding ||
        point.x > point.frameWidth - safePadding ||
        point.y > point.frameHeight - safePadding
      );

      dot.style.left = `${point.x}px`;
      dot.style.top = `${point.y}px`;
      dot.classList.toggle("is-cropped", isCropped);
      dot.classList.toggle("is-edge", isEdge);
      dot.setAttribute("aria-hidden", isCropped || isEdge ? "true" : "false");
    });
  };

  const refresh = () => {
    document.querySelectorAll("body.template-page-press section-product-feature").forEach(updateRoot);
  };

  const observeRoot = (root) => {
    if (roots.has(root)) return;
    roots.add(root);

    const frame = root.querySelector(".product-feature__image");
    const image = frame && frame.querySelector("img");

    if (window.ResizeObserver && frame) {
      new ResizeObserver(() => updateRoot(root)).observe(frame);
    }

    if (image) {
      image.addEventListener("load", () => updateRoot(root), { passive: true });
    }

    updateRoot(root);
  };

  const init = () => {
    document.querySelectorAll("body.template-page-press section-product-feature").forEach(observeRoot);
    refresh();
  };

  window[namespace] = { refresh };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  window.addEventListener("resize", refresh, { passive: true });
  window.addEventListener("orientationchange", refresh, { passive: true });
})();
